import React from 'react';

const HeaderSection = () => {
  return (
    <div className="max-w-3xl mb-12" data-section="overview">
      <h1 className="text-4xl font-bold text-gray-900 mb-4">API Documentation</h1>
      <p className="text-xl text-gray-600 mb-8">
        Learn how to integrate DeltaOps into your workflow using our simple REST API.
      </p>
      {/* <div className="flex gap-4"> */}
        {/* <a
          href="#quick-start"
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700"
        >
          Quick Start Guide
        </a> */}
      {/* </div> */}
    </div>
  );
};

export default HeaderSection;